import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { getRequest } from 'src/utils/request';

import type { RequestDataArray } from 'src/types/requestData';

const mapFieldCategories = (
  fieldCategory: UCM.FieldCategoryRawType,
  fieldCategoryId: string,
): UCM.FieldCategoryType => ({
  id: fieldCategoryId,
  uuid: fieldCategory.uuid,
  position: fieldCategory.position,
  name: {
    de: fieldCategory.name_de,
    en: fieldCategory.name_en,
  },
});

const getFieldCategories = async () => {
  const {
    data: { data },
  } = await getRequest<RequestDataArray<UCM.FieldCategoryRawType>>(
    `${API.GET.fieldCategories}`,
  );

  return data.map(({ attributes, id }) => mapFieldCategories(attributes, id));
};

export const useGetFieldCategories = (
  config: { enabled?: boolean } = { enabled: true },
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.FIELD_CATEGORIES],
    queryFn: () => getFieldCategories(),
    staleTime: 1000 * 60 * 5, // Dashboards refreshed after every 5 minutes automatically
    ...config,
  });
};
